import React from 'react'
import DynamicFormField from '../molecules/DynamicFormField'

const DynamicForm = ({ fields }) => (
  <>
    {fields.map(field => (
      <DynamicFormField key={field.id} {...field} />
    ))}
  </>
)

export default DynamicForm
